import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import baseUrl from "../../API/BaseUrl";

const initialState = {
  AllBrands: [],
  oneBrand: [],
  AddBrand: [],
  editBrand: [],
  DeleteOneBrand: [],
  isLoading: true,
  isSuccess: true,
  errorMessage: "",
};

// to get All Brands
export const GetAllBrands = createAsyncThunk("brands/getAll", async (queryselector) => {
  try {
    const res = await baseUrl.get(`/api/v1/brands?${queryselector}`);
    return res.data;
  } catch (error) {
    return error;
  }
});
// to get Brands by page 
export const GetBrandsByPage = createAsyncThunk("brands/getAll", async (page) => {
  try {
    const res = await baseUrl.get(`/api/v1/brands?limit=1&page=${page}`);
    return res.data;
  } catch (error) {
    return error;
  }
});

// to create new brand
export const CreateNewBrand = createAsyncThunk("brands/addNew", async (formData) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      },
    }
    const res = await baseUrl.post("/api/v1/brands", formData, config)
    return res
  } catch (error) {
    return error
  }
})

// to get one brand
export const getOneBrand = createAsyncThunk("Onebrand/getOne", async (brandID) => {
  try {
    const res = await baseUrl.get(`/api/v1/brands/${brandID}`)
    return res
  } catch (error) {
    return error
  }
})

// to get one brand
export const EditOneBrand = createAsyncThunk("Onebrand/editOne", async ({id, formData}) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      },
    }
    const res = await baseUrl.put(`/api/v1/brands/${id}`, formData, config)
    return res
  } catch (error) {
    return error
  }
})

// Delete one brand
export const deleteOneBrand = createAsyncThunk("Onebrand/deleteOne", async (brandID) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      },
    }
    const res = await baseUrl.delete(`/api/v1/brands/${brandID}`, config)
    return res
  } catch (error) {
    return error
  }
})

const BrandsSlice = createSlice({
  name: "Brands",
  initialState,
  reducers: {},
  extraReducers: {
    [GetAllBrands.pending]: (state, action) => {
      state.isLoading = true;
    },
    [GetAllBrands.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.AllBrands = action.payload;
    },
    [GetAllBrands.rejected]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.errorMessage = action.payload;
    },
    [GetBrandsByPage.pending]: (state, action) => {
      state.isLoading = true;
    },
    [GetBrandsByPage.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.AllBrands = action.payload;

    },
    [GetBrandsByPage.rejected]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.errorMessage = action.payload;
    },
    [CreateNewBrand.pending]: (state, action) => {
      state.isLoading = true
    },
    [CreateNewBrand.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.AddBrand = action.payload;
    },
    [CreateNewBrand.rejected]: (state, action) => {
      state.isLoading = false
      state.errorMessage = action.payload
    },
    [getOneBrand.pending]: (state, action) => {
      state.isLoading = true
    },
    [getOneBrand.fulfilled]: (state, action) => {
      state.isLoading = false
      state.isSuccess = true
      state.oneBrand = action.payload
    },
    [getOneBrand.rejected]: (state, action) => {
      state.isLoading = false
      state.errorMessage = action.payload
    },
    [deleteOneBrand.pending]: (state, action) => {
      state.isLoading = true
    },
    [deleteOneBrand.fulfilled]: (state, action) => {
      state.isLoading = false
      state.isSuccess = true
      state.DeleteOneBrand = action.payload
    },
    [deleteOneBrand.rejected]: (state, action) => {
      state.isLoading = false
      state.errorMessage = action.payload
    },
    [EditOneBrand.pending]: (state, action) => {
      state.isLoading = true
    },
    [EditOneBrand.fulfilled]: (state, action) => {
      state.isLoading = false
      state.isSuccess = true
      state.editBrand = action.payload
    },
    [EditOneBrand.rejected]: (state, action) => {
      state.isLoading = false
      state.errorMessage = action.payload
    }
  },
});

export default BrandsSlice.reducer